export const TEAM_COLORS = [
  '#7c3aed', '#2563eb', '#dc2626', '#16a34a',
  '#d97706', '#db2777', '#0891b2', '#ea580c',
  '#059669', '#9333ea', '#0369a1', '#be185d',
  '#0f766e', '#b45309', '#1d4ed8', '#991b1b',
  '#065f46', '#6b21a8', '#0284c7', '#c2410c',
  '#15803d', '#0e7490', '#b91c1c', '#047857',
  '#1e40af', '#be123c', '#78350f', '#134e4a',
  '#312e81', '#7e1d67',
];
